import { FormSelectOption } from '../entities/form-select-option.entity';

export function formSelectOptionSorter(firstValue: FormSelectOption, secondValue: FormSelectOption): number {
    return firstValue.label.localeCompare(secondValue.label);
}
